import { describeError } from './api.ts';
import { api } from './client.ts';

/** What an add-to-shortlist run did: the ones put on it, and the ones that could not be, with why. */
export interface AddResult {
  added: number;
  failed: Array<{ id: string; reason: string }>;
}

/**
 * Put candidates on a shortlist one request each (the API's unit of audit, history and the
 * candidate's timeline). In sequence, so a long selection never fans out into a burst; one
 * failure (already on it, no access) is reported, not fatal to the rest.
 */
export async function addCandidates(
  shortlistId: string,
  ids: readonly string[],
  opts: { stageId?: string | undefined; visibleToClient: boolean },
): Promise<AddResult> {
  const out: AddResult = { added: 0, failed: [] };
  for (const candidateId of ids) {
    try {
      await api.jobs.addMember(shortlistId, {
        candidateId,
        visibleToClient: opts.visibleToClient,
        ...(opts.stageId ? { stageId: opts.stageId } : {}),
      });
      out.added += 1;
    } catch (err) {
      out.failed.push({ id: candidateId, reason: describeError(err) });
    }
  }
  return out;
}

export function describeAdd(r: AddResult, where: string): string {
  const added = `${r.added} candidate${r.added === 1 ? '' : 's'} added to ${where}`;
  return r.failed.length
    ? `${added}; ${r.failed.length} not added: ${r.failed[0]!.reason}`
    : `${added}.`;
}
